import React, { useEffect } from 'react';
import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
import IntroSection from '../Common/IntroSection';
import TechnologyDetail from './TechnologyDetail';
import AnimatedSection from '../Common/AnimatedSection';
import TechnologyImportance from './TechnologyImportance';
import TechnologiesWeUse from './TechnologiesWeUse';
import TechnologyBenefits from './TechnologyBenefits';
import DentalTechFaq from './DentalTechFaq';

function Technology() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <AnimatedSection id="intro" delay={0}>
        <IntroSection 
          title={"PRISTINE SMILE TECHNOLOGY DENTIST"} 
          about={"Experience the future of dentistry today"} />
      </AnimatedSection>

      <AnimatedSection id="technolog" delay={400}>
        <TechnologyDetail />
      </AnimatedSection>

      <AnimatedSection id='techImportance' delay={600}>
        <TechnologyImportance />
      </AnimatedSection>

      <AnimatedSection id="technologyBenefit" delay={600}>
        <TechnologyBenefits />
      </AnimatedSection>

      <AnimatedSection id='techWeUse' delay={600}>
        <TechnologiesWeUse />
      </AnimatedSection>

      <AnimatedSection id="dentalFaq" delay={1000}>
        <DentalTechFaq />
      </AnimatedSection>

      <AnimatedSection id="visitUs" delay={1200}>
        <VisitUsSection />
      </AnimatedSection>

      <AnimatedSection id="bookVisit" delay={1400}>
        <BookVisitSection />
      </AnimatedSection>
    </div>
  );
}

export default Technology;